// Styles for CobrandTabContainer go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledCobrandTabContainer = styled.div`
  .no-list-style {
    list-style: none;
  }
  .flag-section-container {
    border-radius: ${toRem(14)};
    box-shadow: 0 ${toRem(2)} ${toRem(10)} ${baseVariables.shadows.boxShadowTile};
    padding: 0 ${toRem(24)};
    @media ${baseVariables.mediaQuery.md} {
      padding: 0 ${toRem(60)};
    }
    @media ${baseVariables.mediaQuery.lg} {
      padding: 0 ${toRem(96)};
    }
  }
`;
